import React from 'react';
import styled from 'styled-components';

const CalendarCell = styled.div`
  text-align: center;
  align-self: center;
  padding: 10px 6px;
  width:34px;  /* -----to be changed as 34px-----*/
  user-select: none;
  grid-column: ${props => (props.index % 7) + 1} / span 1; /* -----to be uncommmented-----*/
  // grid-column: ${props => (props.index % 9) + 1} / span 1; /* -----to be removed-----*/

  // &:first-child {  
  //   width:12px;       /* -----to be removed-----*/
  //   padding: 10px 0px;     /* -----to be changed-----*/ 
  //   &:hover{
  //      border: solid 1px transparent;
  //   }  
  // }
  // &:last-child {                  /* -----to be removed-----*/
  //   width:16px; 
  //   padding: 10px 0px;
  //   &:hover{
  //      border: solid 1px transparent;
  //   }
  // }
    
  
  @media(min-width: 361px) {
    padding: 10px 8px;
  }
  
  @media(min-width: 800px) {
    width: auto;
    grid-column: ${props => (props.index % 9) + 1} / span 1;
    &:first-child {
      width:34px; 
      padding: 10px 0px;      
      &:hover{
         border: solid 1px transparent;
      }  
    }
    &:last-child {
      width:34px;
      padding: 10px 6px;
      &:hover{
         border: solid 1px transparent;
      }
    }  
  }
`;

const CalendarDate = styled(CalendarCell)`
  font-weight: 500;
  font-size: 12px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  color: #626262;
  border: ${props => props.alreadySelected ? 'solid 1px #2abcb1' : 'solid 1px transparent'};
  border-radius:  ${props => props.alreadySelected ? '3px' : '0px'};
  box-shadow: none;
  padding: 10px 0;
  width: 48px;  /* -----to be changed as 34px-----*/
  grid-row: ${props => Math.floor(props.index / 7) + 2} / span 1; /* -----to be uncommented-----*/
  :hover {
    border-radius: 5px;
    border: ${props => props.disabled ? 'solid 1px transparent' : 'solid 1px #28b899'};
    color: ${props => props.disabled ? 'inherit' : '#ffffff'};
    background: ${props => props.alreadySelected ? 'none' : '#2abcb1'};
  }
  

  @media(min-width: 800px) {
    width: auto;
    grid-row: ${props => Math.floor(props.index / 9) + 2} / span 1;
    font-size: 18px;
    padding: 10px 15px;
  }
`;

const HighlightedCalendarDate = styled(CalendarDate)`
  border-radius: 5px;
  border: none;
  color: #ffffff;
  background: #2abcb1;
  :hover {
    color: #ffffff;
  }
`;
//color: #28b899;
const TodayCalendarDate = styled(HighlightedCalendarDate)`
  border-radius: 5px;
  border: none;
  color: #2abcb1;
`;

const SelectedCalendarDate = styled(HighlightedCalendarDate)`
  border-radius: 5px;
  border: none;
  color: #ffffff;
  background: #2abcb1;
  :hover {
    color: #ffffff;
  }
`;

//border: solid 1px #28b899;
const DayMonthCell = styled.div`
  font-size: 12px;
  font-weight: 400;

  @media(min-width: 800px) {
    font-size: 14px;
  }
`;
//  color: ${props => props.alreadySelected ? '#2abcb1': 'none' };
const DayDateCell = styled.div`
  font-weight: 500;
`;

export { CalendarCell, CalendarDate, HighlightedCalendarDate, TodayCalendarDate, DayMonthCell, DayDateCell, SelectedCalendarDate };


// WEBPACK FOOTER //
// ./src/components/UI/DateSelector/CalendarCells.js